import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import user from './user';
import role from './role';
import company from './company';
import support from './support';
import bonuses from './bonuses';
import logging from './logging';
import userPermissions from './user-permissions';
import mailing from './mailing';
import partners from './partners';
import { companyPromotionsReducer } from './companyPromotions';

const reducer = combineReducers({
  ...user,
  ...role,
  ...company,
  ...support,
  ...bonuses,
  ...logging,
  ...userPermissions,
  ...mailing,
  ...partners,
  companyPromotions: companyPromotionsReducer,
});

const middleware =
  process.env.NODE_ENV === 'production'
    ? applyMiddleware(thunk)
    : composeWithDevTools(applyMiddleware(thunk));

const store = createStore(reducer, middleware);

export default store;
